import React from 'react';

import HomePageBodyStyles from './_HomePageBodyStyles.module.scss';
import HowToJoinSection from './HowToJoinSection';
import FAQSection from './FAQSection';
import CooperVisionProducts from './CooperVisionProducts';
import ProductTable from '../ProductTable';

const HomePageBody = (): JSX.Element => {
    return (
        <div className={HomePageBodyStyles.container}>
            <div className={HomePageBodyStyles.container__leftBackground} />
            <div className={HomePageBodyStyles.container__rightBackground} />
            <div className={HomePageBodyStyles.container__bottomBackground} />

            <ProductTable />

            <HowToJoinSection />

            <CooperVisionProducts />

            <FAQSection />
        </div>
    );
};

export default HomePageBody;
